

import { useOrderStatus } from "@/sharedData/Order";
import type { OrderType } from "@/types";

import Kanban from "@univdiam/ui/customComponents/Kanban"
import Column from "@univdiam/ui/customComponents/Kanban/Column";
import { useEffect, useState } from "react";
import { kanbanColumns } from "@univdiam/ui/lib/KanbanColumns";
import type { TagLike } from "@univdiam/ui/lib/tagColors";


export type ColumnPagination = {
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
}

type KanbanViewProps = {
  data: OrderType[],
  handleOrderOpen: (id: string, customer_id: string, order_ref: string) => void
  columnVisibility: Record<string, boolean>;
  isAdmin?: boolean;
  adminTags?: TagLike[];
  // Keyed by column id: each column paginates on its own cursor.
  columnPagination?: Record<string, ColumnPagination>;
}

const KanbanView = ({ data, handleOrderOpen, columnVisibility, isAdmin, adminTags = [], columnPagination }: KanbanViewProps) => {
  const [cards, setCards] = useState<OrderType[]>([]);


  // useEffect(() => {
  //   if (data) {
  //     console.log("Data received in KanbanView:", data);
  //     const transformed = (data as OrderType[]).map(order => ({
  //       ...order,
  //       column: order.status
  //     }))
  //     setCards(transformed)
  //   }
  // }, [data])


  useEffect(() => {
    if (!data) {
      setCards([]);
      return;
    }

    // No client-side tag filtering: the API filters by label now, so `data` is
    // already the matching set. Filtering here again only re-hid orders the
    // server had deliberately included.
    const transformed = data.map(order => ({
      ...order,
      column: order.status // maps to Kanban column
    }));

    setCards(transformed);
  }, [data]);




  const { mutate } = useOrderStatus()

  return (
    <div className="h-full w-full">

      <Kanban>
        {kanbanColumns.map(col => {
          if (!columnVisibility[col.id]) return null; // skip hidden columns
          return (
            <Column
              key={col.id}
              title={col.title}
              column={col.id}
              headingColor={col.headingColor}
              cards={cards}
              setCards={setCards}
              isDrag={true}
              handleOrderOpen={handleOrderOpen}
              updateOrderStatus={mutate}
              isAdmin={isAdmin}
              adminTags={adminTags}
              fetchNextPage={columnPagination?.[col.id]?.fetchNextPage}
              hasNextPage={columnPagination?.[col.id]?.hasNextPage}
              isFetchingNextPage={columnPagination?.[col.id]?.isFetchingNextPage}
            />
          );
        })}
      </Kanban>


    </div>
  )
}

export default KanbanView